import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../shared/components/Header/Header';
import Footer from '../shared/components/Footer/Footer';
import './Mk8dxApp.css';

function Mk8dxApp({ auth, fbApp }) {
  // handles screen size to adjust appearance of cups table
  const [width, setWidth] = useState(window.innerWidth);
  
  // Set body theme class for MK8DX
  useEffect(() => {
    document.body.classList.add('mk8dx-theme');
    document.body.classList.remove('world-theme');
    return () => {
      document.body.classList.remove('mk8dx-theme');
    };
  }, []);
  
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  return (
    <div className="mk8dx-app">
      <Header currentGame="mk8dx" />
      <Outlet context={[width, auth, fbApp]} />
      <Footer />
    </div>
  );
}

export default Mk8dxApp;
